import type { School, SchoolCreateInput } from "@app/shared";
import { api, qs } from "../../lib/api";

interface Paged<T> {
  items: T[];
  total: number;
  page: number;
  limit: number;
}

export const schoolsApi = {
  list: (page?: number) => api.get<Paged<School>>(`/schools${qs({ page })}`),
  create: (input: SchoolCreateInput) => api.post<School>("/schools", input),
};
